// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import LazyLoad from 'react-lazyload';
import Dropdown from '../../common/dropdown/Dropdown';
import I18n from '../../../i18n/I18n';
import Icon from '../../common/Icon';
import Helper from '../../../helper/Helper';
import CONFIG from '../../../config';
import DealBadge from '../../../images/common/onDeal.svg';
import VariantsList from './variantsList/VariantsList';
import Button from '../../common/button/Button';
import styles from './OfferDetails.scss';

type Props = {
    data: Object,
    history: Object,
    browser: Object,
    countryCode: string,
    currencyCode: string,
    lang: string,
    onSubmit: Function,
    onBack: Function,
};

type State = {
    uaeChecked: boolean,
    ksaChecked: boolean,
    is_active: number | string,
    offer_note: string,
    // id_processing_time: number | string,
    id_warranty: number | string,
    offer_code: string,
    id_processing_time_error: boolean,
    price_error: Array<string>,
    qty_error: Array<string>,
    sale_start_error: Array<string>,
    sale_end_error: Array<string>,
    sale_price_error: Array<string>,
    updatedVariants: Array<Object>,
    availableWarehouses: Array<Object>,
    changeOffer: boolean,
};

class OfferDetails extends Component<Props, State> {
    onSubmit: Function;
    constructor(props: Object) {
        super(props);

        this.state = {
            uaeChecked:
                (props.data &&
                    (props.data.shipping_countries === '1' ||
                        props.data.shipping_countries === '3')) ||
                this.props.countryCode === 'AE',
            ksaChecked:
                (props.data &&
                    (props.data.shipping_countries === '2' ||
                        props.data.shipping_countries === '3')) ||
                this.props.countryCode === 'SA',
            is_active:
                props.data &&
                props.data.available_offers &&
                !_.isEmpty(props.data.available_offers) &&
                props.data.available_offers.length < 2
                    ? Number(props.data.available_offers[0].is_active)
                    : '0',
            offer_note: props.data ? props.data.offer_note || '' : '',
            // id_processing_time: props.data.processing_time || "1",
            id_warranty: props.data ? props.data.warranty || '0' : '0',
            offer_code: props.data ? props.data.offer_code || '' : '',
            updatedVariants: [],
            id_processing_time_error: false,
            price_error: [],
            qty_error: [],
            sale_start_error: [],
            sale_end_error: [],
            sale_price_error: [],
            availableWarehouses: [],
            changeOffer: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        if (this.props.bySku) {
            if (this.props.data && this.props.data) {
                if (this.props.data.offer_code) {
                    this.props.history.push(
                        `${Helper.getAppDomain(
                            'catalog',
                        )}/${Helper.getLocale()}/catalog/${
                            this.props.data.psku_canonical
                        }`,
                    );
                } else if (
                    this.props.data.available_offers &&
                    !_.isEmpty(this.props.data.available_offers) &&
                    this.props.data.available_offers[0].offer_code
                ) {
                    this.props.history.push(
                        `${Helper.getAppDomain(
                            'catalog',
                        )}/${Helper.getLocale()}/catalog/${
                            this.props.data.available_offers[0].psku_canonical
                        }`,
                    );
                }
            }
        }
    }

    initialize = (variants: Array<Object>) => {
        this.setState({ updatedVariants: variants }, () => {});
    };

    onValueChange = (updatedValue: Object) => {
        const updatedVariants = this.state.updatedVariants;
        if (
            updatedVariants &&
            typeof updatedVariants !== 'undefined' &&
            updatedValue !== null &&
            !_.isEmpty(updatedValue)
        ) {
            const match = updatedVariants.find(
                variant => variant && updatedValue.sku === variant.sku,
            );
            if (match) {
                updatedVariants.splice(updatedVariants.indexOf(match), 1);
            }
            updatedVariants.push(updatedValue);
        }
        const filtered = this.cleanUp(updatedVariants, this.state.offer_code);
        this.setState({ updatedVariants: filtered });
    };

    cleanUp = (updatedVariants: Array<Object>, offerCode) => {
        const match = updatedVariants.find(
            variant => variant && variant.price_updated,
        );
        if (offerCode) {
            _.remove(updatedVariants, function(currentObject) {
                if (!currentObject.offer_code && updatedVariants.length > 1) {
                    return (
                        (currentObject.price === '' ||
                            currentObject.price === null ||
                            !currentObject.price) &&
                        (currentObject.quantity === '' ||
                            currentObject.quantity === null ||
                            !currentObject.quantity)
                    );
                }
            });
        } else if (match) {
            _.remove(updatedVariants, function(currentObject) {
                if (!currentObject.offer_code && updatedVariants.length > 1) {
                    return (
                        (currentObject.price === '' ||
                            currentObject.price === null ||
                            !currentObject.price) &&
                        (currentObject.quantity === '' ||
                            currentObject.quantity === null ||
                            !currentObject.quantity)
                    );
                }
            });
        }

        const filtered = _.map(updatedVariants, function(o) {
            let fullFiltered = o;
            const keys = [
                // "id_processing_time",
                'id_warranty',
                'offer_note',
                'offer_code',
            ];
            const stringifyKeys = ['price', 'sale_price'];
            fullFiltered = _.omit(fullFiltered, [
                'available_warehouses',
                'dialogOpen',
                'salePercentChange',
                'percentChange',
            ]);

            // if (!fullFiltered.stock_updated) {
            //   fullFiltered = _.omit(fullFiltered, ["quantity", "stock_updated"]);
            // }
            if (!fullFiltered.sale_price || fullFiltered.sale_price === '') {
                fullFiltered = _.omit(fullFiltered, [
                    'sale_price',
                    'sale_start',
                    'sale_end',
                ]);
            }

            for (let index = 0; index < keys.length; index++) {
                const key = keys[index];
                if (!fullFiltered[key] || fullFiltered[key] === '') {
                    fullFiltered = _.omit(fullFiltered, [key]);
                }
            }

            for (let index = 0; index < stringifyKeys.length; index++) {
                const key = stringifyKeys[index];
                if (fullFiltered[key]) {
                    fullFiltered[key] = String(fullFiltered[key]);
                }
            }

            if (
                fullFiltered &&
                fullFiltered.stocks &&
                fullFiltered.stocks.length > 0
            ) {
                for (let c = 0; c < fullFiltered.stocks.length; c++) {
                    if (fullFiltered.stocks[c].processing_time) {
                        fullFiltered.stocks[c].processing_time = String(
                            fullFiltered.stocks[c].processing_time,
                        );
                    }
                }
            }

            return fullFiltered;
        });

        return filtered;
    };

    onSubmit() {
        const newState = {};
        let valid = true;
        const updatedVariants = this.cleanUp(
            this.state.updatedVariants,
            this.state.offer_code,
        );

        // if (
        //   updatedVariants &&
        //   !_.isEmpty(updatedVariants) &&
        //   updatedVariants[0] &&
        //   (!updatedVariants[0].id_processing_time ||
        //     updatedVariants[0].id_processing_time === "")
        // ) {
        //   newState[`id_processing_time_error`] = true;
        //   valid = false;
        // }

        let priceError = [];
        let salePriceError = [];
        let saleStartError = [];
        let saleEndError = [];
        let partnerSkuUniqueError = [];

        // _.remove(sampleStocks, function(currentObject) {
        //   return currentObject.is_fbn;
        // });

        _.mapValues(updatedVariants, function(o) {
            if (o.stocks && !_.isEmpty(o.stocks)) {
                _.remove(o.stocks, function(currentObject) {
                    return currentObject.is_fbn;
                });
            }
        });

        _.mapValues(updatedVariants, function(o) {
            if (!o.price || o.price === '' || o.price === null) {
                priceError.push(o.sku);
            }
        });

        const pSkuMandatory = updatedVariants.find(
            variant => variant.partner_sku_mandatory,
        );

        if (!this.state.offer_code || pSkuMandatory) {
            _.mapValues(updatedVariants, function(o) {
                if (
                    !o.partner_sku_unique ||
                    o.partner_sku_unique === '' ||
                    o.partner_sku_unique === null
                ) {
                    partnerSkuUniqueError.push(o.sku);
                }
            });
        }
        _.mapValues(updatedVariants, function(o) {
            if (Number(o.sale_price) >= Number(o.price)) {
                salePriceError.push(o.sku);
            }
        });
        // _.mapValues(updatedVariants, function(o) {
        //   if (
        //     !o.quantity &&
        //     (o.stock_updated || !o.offer_code)
        //     // ((o.quantity === "" || o.quantity === null || !o.quantity) &&
        //     //   !o.stock_updated &&
        //     //   o.price_updated)
        //   ) {
        //     if (!isFbn) {
        //       qtyError.push(o.sku);
        //     }
        //   }
        // });
        _.mapValues(updatedVariants, function(o) {
            if (o.sale_price && !o.sale_start) {
                saleStartError.push(o.sku);
            }
        });
        _.mapValues(updatedVariants, function(o) {
            if (o.sale_price && !o.sale_end) {
                saleEndError.push(o.sku);
            }
        });
        const filtered = _.map(updatedVariants, function(fullFiltered) {
            fullFiltered = _.omit(fullFiltered, ['price_updated']);
            if (!fullFiltered.stock_updated) {
                fullFiltered = _.omit(fullFiltered, [
                    'quantity',
                    'stock_updated',
                ]);
            }
            return fullFiltered;
        });
        if (!_.isEmpty(priceError)) {
            newState[`price_error`] = priceError;
            valid = false;
        }
        if (!_.isEmpty(salePriceError)) {
            newState[`sale_price_error`] = salePriceError;
            valid = false;
        }
        if (!_.isEmpty(partnerSkuUniqueError)) {
            newState[`partnerSkuUniqueError`] = partnerSkuUniqueError;
            valid = false;
        }
        // if (!_.isEmpty(qtyError)) {
        //   newState[`qty_error`] = qtyError;
        //   valid = false;
        // }
        if (!_.isEmpty(saleStartError)) {
            newState[`sale_start_error`] = saleStartError;
            valid = false;
        }
        if (!_.isEmpty(saleEndError)) {
            newState[`sale_start_error`] = saleEndError;
            valid = false;
        }

        for (let i = 0; i < filtered.length; i++) {
            // if(filtered[i].stocks)
            // for (let a = 0; a < filtered[i].stocks.length; a++) {
            //   if (
            //     filtered[i].stocks &&
            //     filtered[i].stocks[a] &&
            //     filtered[i].stock[a].processing_time
            //   ) {
            //     filtered[i].stock[a].processing_time = String(
            //       filtered[i].stock[a].processing_time
            //     );
            //   }
            // }
            _.remove(filtered[i].stocks, function(o) {
                return (
                    o.processing_time === '' ||
                    o.processing_time === null ||
                    !o.processing_time
                );
            });
        }
        this.setState(newState);
        if (!filtered || !filtered.length) valid = false;
        if (valid) {
            this.props.onSubmit(filtered);
        }
    }

    toggleActive() {
        this.setState({
            is_active: Number(!this.state.is_active),
        });
    }

    changeCountry(country: string) {
        var newState = {};
        newState[`${country}Checked`] = !this.state[`${country}Checked`];
        this.setState(newState);
    }

    dropdownChange(e: Object, key: any) {
        var newState = {};
        newState[`${key}`] = e.value;
        this.setState(newState);
    }

    textChange(e: Object, key: any) {
        var newState = {};

        newState[e.target.name] = e.target.value;
        this.setState(newState);
    }

    render() {
        const data = this.props.data || null;
        const isPartnerSkuUnique =
            data && data.variants && data.variants[0]
                ? data.variants[0].is_partner_sku_unique
                : '';
        const partnerSkuUnique =
            data && data.variants && data.variants[0]
                ? data.variants[0].partner_sku_unique
                : '';
        const isFbn =
            data && data.business_model && Number(data.business_model) === 3;
        let shippingCountries = data ? data.shipping_countries : '0';

        if (this.state.ksaChecked) {
            if (this.state.uaeChecked) {
                shippingCountries = '3';
            } else {
                shippingCountries = '2';
            }
        } else {
            shippingCountries = '1';
        }
        const placeholder = (
            <img
                src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
                alt="placeholder"
            />
        );
        const haveVariants =
            data && data.variants ? data.variants.length > 1 : false;

        const merge = (arr1, arr2, key) => {
            var criteria = {};
            criteria[key] = null;
            return _.map(arr1, function(item) {
                criteria[key] = item[key];
                if (isFbn && !_.find(arr2, criteria)) return {};
                else return _.merge(item, _.find(arr2, criteria));
            });
        };

        const variantsMerged1 = merge(
            data && data.variants ? data.variants : [],
            data && data.available_offers ? data.available_offers : [],
            'sku',
        );
        const variantsMerged = merge(
            variantsMerged1,
            data && data.stock ? data.stock : [],
            'sku',
        );
        const variantsNew = [];

        //filter active and non-fbn warehouses
        const availableWarehouses =
            data && data.available_warehouses
                ? data.available_warehouses.filter(
                      warehouse =>
                          warehouse.is_active === 1 && warehouse.is_fbn !== 1,
                  )
                : null;

        //assign available warehouses to each variant
        variantsMerged.map(variant => {
            const newVariant = Object.assign(variant, {
                available_warehouses: availableWarehouses,
            });
            if (variant && variant.stock_group) {
                variant.stock_group.filter(stock => {
                    newVariant.available_warehouses = newVariant.available_warehouses.filter(
                        warehouse =>
                            Number(stock.id_warehouse) !==
                            Number(warehouse.id_warehouse),
                    );
                });
            }
            variantsNew.push(newVariant);
        });

        const warrantyOptions = [
            {
                value: '0',
                label: I18n.getText(
                    'offer.warranty-no-warranty',
                    {},
                    'No Warranty',
                ),
            },
            {
                value: '1',
                label: I18n.getText(
                    'offer.warranty-1-month',
                    {},
                    '1 Month Warranty',
                ),
            },
            {
                value: '3',
                label: I18n.getText(
                    'offer.warranty-3-month',
                    {},
                    '3 Months Warranty',
                ),
            },
            {
                value: '6',
                label: I18n.getText(
                    'offer.warranty-6-month',
                    {},
                    '6 Months Warranty',
                ),
            },
            {
                value: '12',
                label: I18n.getText(
                    'offer.warranty-1-year',
                    {},
                    '1 Year Warranty',
                ),
            },
            {
                value: '24',
                label: I18n.getText(
                    'offer.warranty-2-year',
                    {},
                    '2 Year Warranty',
                ),
            },
            {
                value: '36',
                label: I18n.getText(
                    'offer.warranty-3-year',
                    {},
                    '3 Year Warranty',
                ),
            },
            {
                value: '48',
                label: I18n.getText(
                    'offer.warranty-4-year',
                    {},
                    '4 Year Warranty',
                ),
            },
            {
                value: '60',
                label: I18n.getText(
                    'offer.warranty-5-year',
                    {},
                    '5 Year Warranty',
                ),
            },
        ];
        const dealMatch = variantsNew.find(
            variant =>
                variant &&
                ((variant.deal_price_ae && Number(variant.deal_price_ae)) ||
                    (variant.deal_price_sa && Number(variant.deal_price_sa))),
        );
        return (
            <div>
                <div className={styles.back}>
                    <button onClick={() => this.props.onBack()}>
                        <Icon
                            name={
                                this.props.lang === 'ar'
                                    ? 'fwd-arrow'
                                    : 'back-arrow'
                            }
                            className={styles.backArrow}
                        />
                    </button>
                    {I18n.getText('offer.back', {}, 'Back to Offers')}
                </div>
                <div
                    className={`${styles.ctr} ${
                        haveVariants ? styles.variantsCtr : ''
                    }`}
                >
                    <div className={styles.productImageArea}>
                        {data && data.image_key ? (
                            <div className={styles.imageWrapper}>
                                {dealMatch ? (
                                    <div className={styles.dealCtr}>
                                        <img
                                            src={DealBadge}
                                            alt="deal"
                                            className={styles.dealImg}
                                        />
                                    </div>
                                ) : (
                                    ''
                                )}
                                <LazyLoad
                                    height="100%"
                                    once
                                    placeholder={placeholder}
                                    offset={100}
                                >
                                    <img
                                        src={Helper.getTransformationUrl(
                                            data.image_key,
                                        )}
                                        alt="product"
                                    />
                                </LazyLoad>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={styles.prdDesc}>
                            <div className={styles.prdAbv}>
                                {data && data.image_key ? (
                                    <h4 className={styles.productName}>
                                        {data.title}
                                    </h4>
                                ) : (
                                    ''
                                )}
                                <div className={styles.viewButtonWrapper}>
                                    {data &&
                                    data.sku_config &&
                                    data.offer_code ? (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`${
                                                styles.mainContainer
                                            }`}
                                            href={Helper.getProductUrl(
                                                {
                                                    sku: data.sku_config,
                                                    offerCode: data.offer_code,
                                                },
                                                Helper.getLocale(),
                                            )}
                                        >
                                            <Button
                                                variant="transparent"
                                                className={styles.btn}
                                            >
                                                {I18n.getText(
                                                    'offer.view-on-noon',
                                                    {},
                                                    'View On noon',
                                                )}
                                            </Button>
                                        </a>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            <div
                                className={`${styles.specBox} ${
                                    styles.priceSpec
                                }`}
                            >
                                {data && data.lower_price && !haveVariants ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.lowest-price',
                                                {},
                                                'Lowest Price',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {I18n.formatCurrency(
                                                Helper.formatPrice(
                                                    data.lower_price,
                                                    this.props.currencyCode,
                                                ),
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {data && data.higher_price && !haveVariants ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.highest-price',
                                                {},
                                                'Highest Price',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {I18n.formatCurrency(
                                                Helper.formatPrice(
                                                    data.higher_price,
                                                    this.props.currencyCode,
                                                ),
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {dealMatch &&
                                !_.isEmpty(dealMatch) &&
                                variantsNew &&
                                variantsNew.length === 1 &&
                                dealMatch.deal_price_ae ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.deal-price-uae',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {I18n.formatCurrency(
                                                Helper.formatPrice(
                                                    dealMatch.deal_price_ae,
                                                    'AED',
                                                ),
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {dealMatch &&
                                !_.isEmpty(dealMatch) &&
                                variantsNew &&
                                variantsNew.length === 1 &&
                                dealMatch.deal_price_sa ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.deal-price-ksa',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {I18n.formatCurrency(
                                                Helper.formatPrice(
                                                    dealMatch.deal_price_sa,
                                                    'SAR',
                                                ),
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                            {data && data.breadcrumb ? (
                                <div className={styles.breadcrumb} />
                            ) : (
                                ''
                            )}
                            <div className={styles.specBox}>
                                {data && data.brand ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.brand',
                                                {},
                                                'Brand',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {data.brand}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {data && data.model ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.model',
                                                {},
                                                'Model',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {data.model}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {data &&
                                data.attributes &&
                                !_.isEmpty(JSON.parse(data.attributes)) &&
                                JSON.parse(data.attributes).colour_family ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.color',
                                                {},
                                                'Color',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {
                                                JSON.parse(data.attributes)
                                                    .colour_family
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {data &&
                                data.partner_sku_unique &&
                                !haveVariants ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.p-sku-unique',
                                                {},
                                                'Partner SKU Unique',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {data.partner_sku_unique}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {data && !haveVariants ? (
                                    data.sku ? (
                                        <div className={styles.eachSpec}>
                                            <div className={styles.specTitle}>
                                                {I18n.getText(
                                                    'offer.noon-sku',
                                                    {},
                                                    'noon SKU',
                                                )}
                                            </div>

                                            <div className={styles.specContent}>
                                                {data.sku}
                                            </div>
                                        </div>
                                    ) : (
                                        ''
                                    )
                                ) : data && data.sku_config ? (
                                    <div className={styles.eachSpec}>
                                        <div className={styles.specTitle}>
                                            {I18n.getText(
                                                'offer.sku',
                                                {},
                                                'SKU',
                                            )}
                                        </div>

                                        <div className={styles.specContent}>
                                            {data.sku_config}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={styles.productDesc}>
                        <div className={styles.titleWrapper}>
                            <h4 className={styles.offerTitle}>
                                {I18n.getText(
                                    'offer.offer-details',
                                    {},
                                    'Offer Details',
                                )}
                            </h4>
                            {!haveVariants ? (
                                <div className={styles.toggleSwitch}>
                                    <input
                                        className={styles.toggle}
                                        type="checkbox"
                                        checked={Number(this.state.is_active)}
                                        onChange={() => this.toggleActive()}
                                    />
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div className={styles.formCtr}>
                            {this.props.seller.is_crossborder && false ? (
                                <div className={styles.inputWrapper}>
                                    <p className={styles.inputTitle}>
                                        {I18n.getText(
                                            'offer.sell-location',
                                            {},
                                            'Sell My Products In',
                                        )}
                                    </p>
                                    <div className={styles.checkboxWrapper}>
                                        {this.props.countryCode === 'AE' ? (
                                            <span>
                                                <input
                                                    type="checkbox"
                                                    name="location"
                                                    id="uae"
                                                    checked={
                                                        this.props
                                                            .countryCode ===
                                                            'AE' ||
                                                        this.state.uaeChecked
                                                    }
                                                    onChange={
                                                        this.props
                                                            .countryCode ===
                                                        'AE'
                                                            ? () => {}
                                                            : () =>
                                                                  this.changeCountry(
                                                                      'uae',
                                                                  )
                                                    }
                                                    className={
                                                        styles.locCheckbox
                                                    }
                                                />
                                                <label
                                                    htmlFor="uae"
                                                    className={styles.locLabel}
                                                >
                                                    {I18n.getText(
                                                        'offer.uae',
                                                        {},
                                                        'United Arab Emirates',
                                                    )}
                                                </label>
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                        <span>
                                            <input
                                                type="checkbox"
                                                name="location"
                                                id="ksa"
                                                checked={this.state.ksaChecked}
                                                onChange={() =>
                                                    this.changeCountry('ksa')
                                                }
                                                className={styles.locCheckbox}
                                            />
                                            <label
                                                htmlFor="ksa"
                                                className={styles.locLabel}
                                            >
                                                {I18n.getText(
                                                    'offer.ksa',
                                                    {},
                                                    'Saudi Arabia',
                                                )}
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}

                            <VariantsList
                                variants={variantsNew}
                                currencyCode={this.props.currencyCode}
                                shippingCountries={shippingCountries}
                                offerNote={this.state.offer_note}
                                onValueChange={this.onValueChange}
                                initialize={this.initialize}
                                seller={this.props.seller}
                                // processingTime={this.state.id_processing_time}
                                warranty={this.state.id_warranty}
                                countryCode={this.props.countryCode}
                                isFbn={isFbn}
                                priceError={this.state.price_error}
                                salePriceError={this.state.sale_price_error}
                                partnerSkuUniqueError={
                                    this.state.partnerSkuUniqueError
                                }
                                qtyError={this.state.qty_error}
                                saleStartError={this.state.sale_start_error}
                                saleEndError={this.state.sale_end_error}
                                browser={this.props.browser}
                                is_active={this.state.is_active}
                                warehouses={
                                    this.props.data
                                        ? this.props.data.available_warehouses
                                        : []
                                }
                                isPartnerSkuUnique={isPartnerSkuUnique}
                                partnerSkuUnique={partnerSkuUnique}
                            />
                            <div className={styles.inputWrapper}>
                                <p className={styles.inputTitle}>
                                    {I18n.getText(
                                        'offer.warranty',
                                        {},
                                        'Warranty',
                                    )}
                                </p>
                                <div className={styles.checkboxWrapper}>
                                    <div className={styles.dropdownWrapper}>
                                        {I18n.getComponent(
                                            formattedValue => (
                                                <Dropdown
                                                    options={warrantyOptions}
                                                    height="short"
                                                    placeholder={formattedValue}
                                                    value={
                                                        this.state.id_warranty
                                                    }
                                                    onChange={e =>
                                                        this.dropdownChange(
                                                            e,
                                                            'id_warranty',
                                                        )
                                                    }
                                                />
                                            ),
                                            'dropdown.select',
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.inputWrapper}>
                                <p className={styles.inputTitle}>
                                    {I18n.getText(
                                        'offer.offer-note',
                                        {},
                                        'Offer Note',
                                    )}
                                </p>
                                <div className={styles.checkboxWrapper}>
                                    <textarea
                                        rows="4"
                                        className={styles.textArea}
                                        value={this.state.offer_note}
                                        name="offer_note"
                                        onChange={e => this.textChange(e)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.btnWrapper}>
                            <Button
                                variant="transparent"
                                className={styles.cancelBtn}
                                onClick={() => this.props.onBack()}
                            >
                                {I18n.getText(
                                    'offer.offer-cancel',
                                    {},
                                    'Cancel',
                                )}
                            </Button>
                            <Button onClick={this.onSubmit}>
                                {data && data.offer_code
                                    ? I18n.getText(
                                          'offer.offer-update',
                                          {},
                                          'Update Offer',
                                      )
                                    : I18n.getText(
                                          'offer.offer-add',
                                          {},
                                          'Add Offer',
                                      )}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default OfferDetails;



// WEBPACK FOOTER //
// ./src/components/products/offerDetails/OfferDetails.js